import React from 'react'
import PropTypes from 'prop-types'
import {Text, Stack, Divider} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {SHIPPING_METHODS} from '../constant'

export const OrderDate = ({order}) => {
    const {bopisStoreNumber, shippingMethod, orderDate} = order
    const isPickupInStore = Boolean(bopisStoreNumber) && !shippingMethod
    const displayShippingMethod = isPickupInStore
        ? `${SHIPPING_METHODS.PICKUP_IN_STORE.DISPLAY_NAME} ${SHIPPING_METHODS.PICKUP_IN_STORE.EST_ARRIVAL_TIME}`
        : shippingMethod || '-'

    return (
        <Stack spacing={0} mb="6">
            <Text fontSize="sm" lineHeight="18px">
                <FormattedMessage
                    defaultMessage="Order Date: {orderDate}"
                    id="account _order_detail.label.order_date"
                    values={{orderDate: order.orderDate}}
                />
            </Text>
            <Text fontSize="sm" lineHeight="18px">
                <FormattedMessage
                    defaultMessage="Shipping Method: {shippingMethod}"
                    id="account_order_detail.shipping_method"
                    values={{shippingMethod: displayShippingMethod}}
                />
            </Text>
        </Stack>
    )
}

export const OrderStatus = ({order}) => {
    return (
        <>
            <Stack spacing={0} mb={4}>
                <Text fontSize="md" fontWeight={700} textTransform="uppercase" lineHeight="20px">
                    <FormattedMessage
                        defaultMessage="Status: {orderStatus}"
                        id="account_order_detail.label.order_status"
                        values={{orderStatus: order.orderStatus}}
                    />
                </Text>
                {order.dateDelivered && (
                    <Text fontSize="sm">
                        <FormattedMessage
                            defaultMessage="Delivered on: {dateDelivered}"
                            id="account_order_detail.label.order_delivered"
                            values={{dateDelivered: order.dateDelivered}}
                        />
                    </Text>
                )}
            </Stack>
            <OrderDate order={order} />
            <Divider mb={4} borderColor="grey.300" />
        </>
    )
}

OrderDate.propTypes = {
    order: PropTypes.shape({
        orderDate: PropTypes.string,
        shippingMethod: PropTypes.string
    })
}

OrderStatus.propTypes = {
    order: PropTypes.shape({
        orderStatus: PropTypes.string,
        dateDelivered: PropTypes.string,
        orderDate: PropTypes.string,
        shippingMethod: PropTypes.string
    })
}
